const bodyScrollLock = require('body-scroll-lock')
const disableBodyScroll = bodyScrollLock.disableBodyScroll
const clearAllBodyScrollLocks = bodyScrollLock.clearAllBodyScrollLocks

const TOGGLE_MENU_SELECTOR = '.js-menu-toggle'
const HEADER_NAV_SELECTOR = '.js-header-nav'
const SUB_MENU_SELECTOR = '.js-header-submenu'
const MENU_ITEM_SELECTOR = '.js-header-menu-item'
const ITEM_LINK_SELECTOR = '.js-header-menu-item-link'
const SUB_ITEM_LINK_SELECTOR = '.js-header-submenu-sub-item-link'
const BACK_SELECTOR = '.js-back-main-menu'
const SEARCH_BUTTON_SELECTOR = '.js-search-button'
const SEARCH_OUTER_SELECTOR = '.js-search-outer'
const SEARCH_INPUT_SELECTOR = '.js-search-input'
const LOGO_IMAGE_SELECTOR = '.js-logo-image'
const CARDS_WRAPPER_SELECTOR = '.js-header-cards'
const CARD_SELECTOR = '.js-submenu-is-card'
const VISIBLE_CLASS = 'visible'
const HIDDEN_MOBILE_CLASS = 'is-hidden-mobile'
const HIDDEN_DESKTOP_CLASS = 'is-hidden-desktop'
const HEADER_SUB_MENU_CLASS = 'header--show-sub-menu'

const BREAKPOINT_DESKTOP = 1024

module.exports = function (el) {
  const $el = $(el)
  const $window = $(window)

  const $mobileMenuToggle = $(TOGGLE_MENU_SELECTOR)
  const $headerNavSelector = $(HEADER_NAV_SELECTOR)
  const $subMenuSelectors = $(SUB_MENU_SELECTOR)
  const $links = $(ITEM_LINK_SELECTOR)
  const $menuItems = $(MENU_ITEM_SELECTOR)
  const $backMainMenu = $(BACK_SELECTOR)
  const $searchTrigger = $(SEARCH_BUTTON_SELECTOR)
  const $searchContainer = $(SEARCH_OUTER_SELECTOR)
  const $search = $(SEARCH_INPUT_SELECTOR)
  const $logoImageEl = $(LOGO_IMAGE_SELECTOR)
  const $cardsWrapperEls = $(CARDS_WRAPPER_SELECTOR)
  const subLinks = document.querySelectorAll(SUB_ITEM_LINK_SELECTOR)
  const $lastLink = subLinks[subLinks.length - 1]
  const $searchInput = $(document.querySelector('.js-search-input'))

  var newColor = 'F24C31'
  var currentColor = ''
  var currentLogoImage = ''

  // get current logo link and logo image
  if ($logoImageEl) {
    currentLogoImage = $logoImageEl.attr('src')
  }


  // get current header color based on body data-attr
  // save it as a data-attr on header element
  switch ($('body').attr('data-site')) {
    case 'site-type--film-independent':
      currentColor = '#F24C31'
      break
    case 'site-type--spirit-awards':
      currentColor = '#4866E3'
      break
    case 'site-type--la-film-festival':
      currentColor = '#F8AF2A'
      break
    case 'site-type--presents':
    case 'site-type--lacma':
      currentColor = '#A446AA'
      break
    case 'site-type--programs':
      currentColor = '#91C84E'
      break
    default:
      currentColor = '#F24C31'
  }

  $el.attr('data-color', currentColor)

  const isMobile = function () {
    return window.innerWidth < BREAKPOINT_DESKTOP
  }

  // primary nav (mobile)
  const setHeaderNavHeight = function () {
    if (isMobile()) {
      const height = window.innerHeight - $el.outerHeight()
      if ($headerNavSelector) {
        $headerNavSelector.outerHeight(height)
      }
      if ($subMenuSelectors) {
        $subMenuSelectors.outerHeight(height)
      }
    } else {
      $headerNavSelector && $headerNavSelector.outerHeight('')
      $subMenuSelectors && $subMenuSelectors.outerHeight('')
    }
  }

  setHeaderNavHeight()

  const hideBackButton = function () {
    $el.removeClass(HEADER_SUB_MENU_CLASS)
  }

  const showBackButton = function ()  {
    setTimeout(function () {
      $el.addClass(HEADER_SUB_MENU_CLASS)
    }, 300)
  }

  const closeAllSubNav = function () {
    $menuItems.removeClass(VISIBLE_CLASS)
    $links.attr('aria-expanded', false)
    changeHeaderColor(currentColor)
  }

  const toggleSubNav = function (e) {
    if (isMobile()) {
      e.preventDefault()
    }
    const target = e.target
    const link = target.closest(ITEM_LINK_SELECTOR)
    const parent = target.closest(MENU_ITEM_SELECTOR)
    const subMenu = $(link).next(SUB_MENU_SELECTOR)
    if ($(parent).hasClass(VISIBLE_CLASS)) {
      $(parent).removeClass(VISIBLE_CLASS)
      hideBackButton()
      $(link).attr('aria-expanded', false)
    } else {
      $(parent).addClass(VISIBLE_CLASS)
      showBackButton()
      updateBackground(target)
      $(link).attr('aria-expanded', true)
      disableBodyScroll(subMenu[0])
    }
  }

  const toggleMenu = function () {
    $el.toggleClass(VISIBLE_CLASS)
    if ($el.hasClass(VISIBLE_CLASS)) {
      disableBodyScroll($headerNavSelector[0])
    } else {
      closeAllSubNav()
      hideBackButton()
      clearAllBodyScrollLocks()
    }
  }

  $links.on('click', toggleSubNav)

  $mobileMenuToggle.on('click', function (e) {
    e.preventDefault()
    toggleMenu()
  })

  $backMainMenu.on('click', function () {
    hideBackButton()
    closeAllSubNav()
  })

  $window.resize(function() {
    setHeaderNavHeight()
    if (!isMobile()) {
      closeAllSubNav()
      hideBackButton()
      if ($el.hasClass(VISIBLE_CLASS)) {
        $el.removeClass(VISIBLE_CLASS)
        disableBodyScroll($headerNavSelector[0])
      }
    }
  })

  const openSubNavOnEnter = function (e) {
    closeAllSubNav()
    const target = e.target
    const menuItem = $(target).closest(MENU_ITEM_SELECTOR)
    const link = $(target).find(ITEM_LINK_SELECTOR)
    const isActive = menuItem.hasClass(VISIBLE_CLASS)

    if (!isActive) {
      $(menuItem).addClass(VISIBLE_CLASS)
      link.attr('aria-expanded', true)
    }
  }

  const changeHeaderColor = function (color) {
    $backMainMenu.css('background', color)
    $(el).css('background', color)
    $subMenuSelectors.css('background', color)
  }

  const changeLogo = function (logo) {
    if ($logoImageEl) {
      $logoImageEl.attr('src', logo)
    }
  }

  const updateBackground = function (target) {
    const hoverText = 'hover-'
    const menuItem = $(target).closest(MENU_ITEM_SELECTOR)
    const classArr = $(menuItem).attr('class').split(' ')
    const hoverClass = classArr.find(function (item) {
      return item.includes(hoverText)
    })
    if (hoverClass) {
      const targetClass = hoverClass.replace('hover-', '')
      switch (targetClass) {
        case 'menu-fi-menu':
          newColor = '#F24C31'
          break
        case 'menu-fi-spirit':
          newColor = '#4866E3'
          break
        case 'menu-laff':
          newColor = '#F8AF2A'
          break
        case 'menu-fi-presents':
          newColor = '#A446AA'
          break
        case 'menu-fi-programs':
          newColor = '#91C84E'
          break
        default:
          newColor = '#F24C31'
      }
      changeHeaderColor(newColor)
    }
  }

  const changeColor = function (e) {
    const target = e.target
    const menuItem = $(target).closest(MENU_ITEM_SELECTOR)
    const dataLogo = $(menuItem).attr('data-logo')
    changeLogo(dataLogo)
    updateBackground(target)
  }

  $menuItems.on('mouseenter', function (e) {
    if (isMobile()) return
    openSubNavOnEnter(e)
    changeColor(e)
  })
  $menuItems.on('mouseleave', function (e) {
    if (isMobile()) return
    closeAllSubNav(e)
    changeHeaderColor(currentColor)
    changeLogo(currentLogoImage)
  })
  document.querySelectorAll(ITEM_LINK_SELECTOR).forEach(function(i) {
    $(i).on('focus', function(e) {
      if (isMobile()) return
      openSubNavOnEnter(e)
      changeColor(e)
      $(document).keyup(function(e) {
        const iParent = $(i).closest('li.js-header-menu-item')
        if (e.key === 'Escape') {
          if ($(iParent).hasClass(VISIBLE_CLASS)) {
            $(iParent).removeClass(VISIBLE_CLASS)
          }
        }
      });
    });
  })
  if ($lastLink) {
    $($lastLink).on('blur', function(e) {
      if (isMobile()) return
      const subLinkParent = $(this).closest('li.js-header-menu-item')
      if ($(subLinkParent).hasClass(VISIBLE_CLASS)) {
        $(subLinkParent).removeClass(VISIBLE_CLASS)
      } else {
        $(subLinkParent).addClass(VISIBLE_CLASS)
      }
    });
  }

  if ($searchInput) {
    $($searchInput).on('blur', function(e) {
      $($searchTrigger).focus()
    })
    $($searchInput).on('focus', function(e) {
      $(document).keyup(function(e) {
        if (e.key === 'Escape') {
          $($searchContainer).removeClass('open')
          $($searchTrigger).focus()
        }
      });
    })
  }

  // search
  $searchTrigger.on('click', function (e) {
    e.preventDefault()

    $searchContainer.toggleClass('open')

    if ($searchContainer.hasClass('open')) {
      $search.focus()
    } else {
      $search.blur()
    }
  })

  // Copy is-button from first card to last card to show only mobile
  $cardsWrapperEls.each(function() {
    const $subMenuIsCards = $(this).find(CARD_SELECTOR)
    const $button = $(this).find('.is-button')
    if ($button && $button.length === 1 && $subMenuIsCards && $subMenuIsCards.length > 1) {
      $subMenuIsCards.first().addClass(HIDDEN_MOBILE_CLASS)
      $subMenuIsCards.last().addClass(HIDDEN_DESKTOP_CLASS)
      $subMenuIsCards.last().append($button.clone())
    }
  })
}
